import { materializeChronodata, useLazyMaterializeChronodata } from "../reducers/blobSlice";
import { materializeChronoentity, useMaterializeChronoentity } from "../reducers/entitySlice";

export async function materialize(realizationContext, obj) {
    const step1 = await materializeChronodata(realizationContext, obj);
    const step2 = await materializeChronoentity(realizationContext, step1);
    return step2;
}

export const useMaterialization = (data) => {
    const step1 = useLazyMaterializeChronodata(data);
    const step2 = useMaterializeChronoentity(step1);
    return step2;
}